<template>
  <div
    :class="jel_getClassObject(content, { [content.type]: true })"
    class="contenu_html_taille_defaut"
    v-html="content.codeHTML"
  ></div>
</template>

<script>
export default {
  name: 'CodeHTML',
  props: { content: { type: Object, required: true } },
};
</script>

<style lang="scss" scoped>
.row {
  background-position: center;
  background-repeat: no-repeat;
}
.row.bgcover {
  background-size: cover;
}
.container-fluid {
  padding: 0;
}

// Ajouter configuration des bordures au composant CodeHTML dans Magnolia
.texte_html_border {
  border: solid 2px #efefef;
  border-radius: ms(0);
}

.contenu_html_taille_defaut {
  font-size: ms(0);
}

::v-deep .legal-txt {
  font-size: ms(-1);
}
</style>
